import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { getAccountUsers } from './account-user-data.reducer';
import { AccountUser } from './account-user.model';

@Injectable()
export class AccountUserDataStore {
  accountUsers$: Observable<List<AccountUser>> = this._store.select(
    getAccountUsers
  );

  constructor(private _store: Store<any>) {}
}
